<template>
  <div id="law">
    <div class="box-title">
      <p>{{ $t("message.strid29") }}</p>
    </div>
    <div class="law-box" v-html="$t('message.strid69')"></div>
    <div class="check-box" @click="checkFn">
      <div class="check" :class="error ? 'error' : ''">
        <img v-if="check" class="icon" src="@/assets/images/right.png" alt="">
      </div>
      <div class="text" :class="error ? 'error' : ''">{{ $t("message.strid31") }}</div>
    </div>
    <div class="btn-group">
      <Button type="border" @click="backFn">{{ $t("message.strid43") }}</Button>
      <Button :type="check ? 'active' : 'default'" @click="jump('form')">{{ $t("message.strid30") }}</Button>
    </div>
    <div class="blank"></div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Button from "@/components/Button"
export default {
  components: {
    Button
  },
  computed: {
    ...mapState(["_description"]),
  },
  data () {
    return {
      check: false,
      error: false
    }
  },
  mounted () {
    
  },
  methods: {
    checkFn () {
      this.check = !this.check
      if (this.check) {
        this.error = false
      }
    },
    jump (name) {
      if (this.check) {
        window.sessionStorage.setItem("enter", 1);
        this.$router.push({name, query: {t: 1}})
      } else {
        this.error = true
      }
    },
    backFn () {
      this.$router.go(-1)
    }
  }
}
</script>>

<style lang="scss">
@media screen and (min-width: $mimViewWidth) {
  @import "@/assets/scss/views/law.scss";
}
@media screen and (max-width: $maxViewWidth) {
  @import "@/assets/scss/views/m/law.scss";
}
</style>